import * as AirLitigation from "./air-litigation"; 

export * from "./types";

function getMachine(litigationName: string, versionNumber: number) {
  if (litigationName === "AIR_LITIGATION") {
    return AirLitigation.versions[versionNumber];
  }
}

export {
  getMachine,
  AirLitigation,
};